import { useNetworkStore } from "../../store/networkStore";
import { Input } from "@vintecc/components";
import { useMemo, useState } from "react";
import { DebugRequestEntry } from "./DebugRequestEntry";

export const DebugRequestExplorer: React.FC = () => {
  const { networkLogs } = useNetworkStore();
  const [search, setSearch] = useState("");

  const filteredLogs = useMemo(() => {
    const reverseLogs = [...networkLogs].reverse();
    if (!search) return reverseLogs;
    return reverseLogs.filter((log) => log.endpoint.includes(search) || log.method.includes(search) || log.status?.toString().includes(search));
  }, [networkLogs, search]);

  return (
    <div>
      <Input
        testId="debug-request-search"
        placeholder="Search requests..."
        label="Search Requests"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="sticky top-0 bg-white py-4"
      />
      <div className="w-full text-left border-collapse" role="table">
        {filteredLogs.map((log) => {
          return <DebugRequestEntry key={log.id} log={log} />;
        })}
      </div>
    </div>
  );
};
